<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content pa-0"
    fluid
  >
    <v-form
      v-model="valid"
      ref="form"
    >
      <!-- Hero section -->
      <page-hero
        title="Mijn mening"
        intro="Wij stellen uw mening sterk op prijs. De informatie die wij van u ontvangen, stelt ons in de mogelijkheid om nog beter te begeleiden en ondersteunen bij een persoonlijke uitvaart."
      />

      <!-- Klant selectie -->
      <v-row justify="center">
        <v-col
          class="center"
          cols="12"
          md="10"
          lg="8"
        >
          <div class="enquete-card">
            <div class="enquete-card-header">
              <v-icon
                color="#907322"
                size="22"
              >
                mdi-account-outline
              </v-icon>
              <h2 class="enquete-card-title">
                Dit is de mening van
              </h2>
            </div>
            <v-autocomplete
              v-model="idEnqueteKlant"
              base-color="primary"
              bg-color="white"
              color="primary"
              density="compact"
              item-value="idEnqueteKlant"
              item-title="naam"
              :items="Klanten"
              variant="outlined"
              @update:modelValue="KlantSelected"
            />
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="klantDetails.familienaam"
                  base-color="primary"
                  bg-color="white"
                  color="primary"
                  density="compact"
                  label="Uw naam"
                  ref="txtFamilienaam"
                  :rules="[validationMixin.rules.required]"
                  variant="outlined"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="klantDetails.voornaam"
                  base-color="primary"
                  bg-color="white"
                  color="primary"
                  density="compact"
                  label="Uw voornaam"
                  ref="txtVoornaam"
                  :rules="[validationMixin.rules.required]"
                  variant="outlined"
                />
              </v-col>
            </v-row>
            <v-text-field
              v-model="klantDetails.relatie"
              base-color="primary"
              bg-color="white"
              color="primary"
              density="compact"
              label="Uw relatie tot de overledene"
              ref="txtRelatie"
              :rules="[validationMixin.rules.required]"
              variant="outlined"
            />
          </div>
        </v-col>
      </v-row>

      <!-- Vraaggroepen -->
      <v-row
        v-for="(vraagGroepItem, index) in vraagGroep"
        justify="center"
        :key="index"
      >
        <v-col
          class="center"
          cols="12"
          md="10"
          lg="8"
        >
          <div class="enquete-card">
            <div class="enquete-card-header">
              <v-icon
                color="#907322"
                size="22"
              >
                mdi-comment-text-outline
              </v-icon>
              <h2 class="enquete-card-title">
                {{ vraagGroepItem.titel }}
              </h2>
            </div>

            <div
              v-for="(vraag, index2) in vraagGroepItem.vragen"
              class="enquete-vraag"
              :key="`${index}-${index2}`"
            >
              <p class="enquete-vraag-tekst">
                {{ vraag.tekst }}
              </p>

              <!-- Radio buttons -->
              <v-radio-group
                v-if="vraag.enqueteTypeVraag === constantMixin.codes.enqueteTypeVraag.values.radiobutton"
                v-model="vraag.klantAntwoorden[0]"
              >
                <v-row class="py-0">
                  <v-col
                    v-for="(antwoord, index3) in vraag.antwoorden"
                    cols="12"
                    sm="4"
                    lg="2"
                    :key="`${index}-${index2}-${index3}`"
                  >
                    <v-radio
                      base-color="primary"
                      color="primary"
                      :label="antwoord.tekst"
                      :value="antwoord.idEnqueteAntwoord"
                    />
                  </v-col>
                </v-row>
              </v-radio-group>

              <!-- Checkboxes -->
              <v-row
                v-else-if="vraag.enqueteTypeVraag === constantMixin.codes.enqueteTypeVraag.values.checkbox"
                class="py-0"
              >
                <v-col
                  v-for="(antwoord, index3) in vraag.antwoorden"
                  cols="12"
                  sm="4"
                  lg="2"
                  :key="`${index}-${index2}-${index3}`"
                >
                  <v-checkbox
                    v-model="vraag.klantAntwoorden[index3]"
                    base-color="primary"
                    color="primary"
                    :label="antwoord.tekst"
                    :value="antwoord.idEnqueteAntwoord"
                  />
                </v-col>
              </v-row>

              <!-- Long text -->
              <v-textarea
                v-else-if="vraag.enqueteTypeVraag === constantMixin.codes.enqueteTypeVraag.values.langeTekst"
                v-model="vraag.klantAntwoorden[0]"
                auto-grow
                base-color="primary"
                bg-color="white"
                color="primary"
                density="compact"
                variant="outlined"
              />

              <!-- Short text -->
              <v-text-field
                v-else-if="vraag.enqueteTypeVraag === constantMixin.codes.enqueteTypeVraag.values.korteTekst"
                v-model="vraag.klantAntwoorden[0]"
                base-color="primary"
                bg-color="white"
                color="primary"
                density="compact"
                variant="outlined"
              />
            </div>
          </div>

          <!-- Save button after last group -->
          <div
            v-if="index + 1 === vraagGroep.length"
            class="d-flex justify-end mt-4 mb-8"
          >
            <v-btn
              color="primary"
              rounded
              @click="SaveEnquete"
            >
              <v-icon
                class="mr-1"
                size="18"
              >
                mdi-content-save-outline
              </v-icon>
              Opslaan
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>

    <!-- Success dialog -->
    <v-dialog
      v-model="showDialog"
      max-width="400px"
      persistent
    >
      <v-card class="enquete-dialog">
        <v-icon
          class="enquete-dialog-icon"
          color="#6B8E6F"
          size="48"
        >
          mdi-check-circle-outline
        </v-icon>
        <h2 class="enquete-dialog-title">
          Uw mening werd opgeslagen
        </h2>
        <v-btn
          class="mt-4"
          color="primary"
          rounded
          @click="CloseDialog"
        >
          OK
        </v-btn>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import PageHero from '@/components/PageHero.vue'
import authenticationMixin from '@/mixins/authenticationMixin'
import commonMixin from '@/mixins/commonMixin'
import constantMixin from '@/mixins/constantMixin'
import errorMixin from '@/mixins/errorMixin'
import validationMixin from '@/mixins/validationMixin'
import klantService from '@/services/klantService'

export default {
  name: 'EnqueteComponent',
  components: {
    PageHero
  },
  mixins: [
    authenticationMixin,
    commonMixin,
    constantMixin,
    errorMixin,
    validationMixin
  ],
  data () {
    return {
      idEnqueteKlant: '00000000-0000-0000-0000-000000000000',
      klant: [],
      klantDetails: {
        familienaam: null,
        idEnqueteKlant: null,
        relatie: null,
        voornaam: null
      },
      showDialog: false,
      valid: false,
      vraagGroep: []
    }
  },
  computed: {
    Klanten () {
      const klanten = this.CommonMixin_Clone(this.klant)

      klanten.unshift(
        this.CommonMixin_Clone({
          familienaam: null,
          idDossier: null,
          idEnqueteKlant: this.constantMixin.guids.empty,
          isNew: true,
          naam: 'Nieuw persoon',
          naamOmgekeerd: 'Nieuw persoon',
          relatie: null,
          voornaam: null
        })
      )

      return klanten
    },
    KlantAntwoorden () {
      const klantAntwoorden = []

      this.vraagGroep.forEach(vraagGroep => {
        vraagGroep.vragen.forEach(vraag => {
          const klantAntwoord = {
            idEnqueteKlant: this.klantDetails.idEnqueteKlant,
            idEnqueteVraag: vraag.idEnqueteVraag
          }

          if (vraag.enqueteTypeVraag === this.constantMixin.codes.enqueteTypeVraag.values.radiobutton) {
            if (vraag.klantAntwoorden[0]) {
              klantAntwoord.idEnqueteAntwoord = vraag.klantAntwoorden[0]
              klantAntwoorden.push(klantAntwoord)
            }
          } else if (vraag.enqueteTypeVraag === this.constantMixin.codes.enqueteTypeVraag.values.checkbox) {
            vraag.klantAntwoorden.forEach(antwoord => {
              if (antwoord) {
                const klantAntwoord2 = this.CommonMixin_Clone(klantAntwoord)
                klantAntwoord2.idEnqueteAntwoord = antwoord
                klantAntwoorden.push(klantAntwoord2)
              }
            })
          } else if (vraag.enqueteTypeVraag === this.constantMixin.codes.enqueteTypeVraag.values.langeTekst || vraag.enqueteTypeVraag === this.constantMixin.codes.enqueteTypeVraag.values.korteTekst) {
            if (vraag.klantAntwoorden[0]) {
              klantAntwoord.antwoord = vraag.klantAntwoorden[0]
              klantAntwoorden.push(klantAntwoord)
            }
          }
        })
      })

      return klantAntwoorden
    }
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    klantService.Init(this)
    this.GetEnqueteLists()
  },
  methods: {
    async CloseDialog () {
      this.CommonMixin_Load(this.$options.name, true)
      await this.GetEnqueteListKlant()
      this.CommonMixin_Load(this.$options.name, false)
      this.KlantSelected(null)
      this.KlantSelected(this.idEnqueteKlant)
      this.showDialog = false
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    async GetEnqueteListKlant () {
      const resp = await klantService.GetEnqueteListKlant()

      if (resp && (resp.data || resp.data !== '')) {
        this.klant = resp.data
      }
    },
    async GetEnqueteLists () {
      this.CommonMixin_Load(this.$options.name, true)
      await this.GetEnqueteListKlant()
      await this.GetEnqueteListVraagGroep()
      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetEnqueteListVraagGroep () {
      const resp = await klantService.GetEnqueteListVraagGroep(this.idEnqueteKlant)

      if (resp && (resp.data || resp.data !== '')) {
        this.vraagGroep = resp.data
      }
    },
    KlantSelected (idEnqueteKlant) {
      this.klantDetails = this.Klanten.find(klant => klant.idEnqueteKlant === idEnqueteKlant)

      if (idEnqueteKlant) {
        this.GetEnqueteListVraagGroep()
      }
    },
    async SaveEnquete () {
      this.$refs.form.validate()

      if (this.valid) {
        const enquete = {
          klant: this.klantDetails,
          klantAntwoorden: this.KlantAntwoorden
        }

        const resp = await klantService.SaveEnquete(enquete)

        if (resp && (resp.data || resp.data !== '')) {
          this.showDialog = true
        }
      } else {
        if (!this.klantDetails.familienaam) {
          this.$refs.txtFamilienaam.focus()
        } else if (!this.klantDetails.voornaam) {
          this.$refs.txtVoornaam.focus()
        } else if (!this.klantDetails.relatie) {
          this.$refs.txtRelatie.focus()
        }
      }
    }
  }
}
</script>

<style scoped>
.enquete-card {
  border: 1px solid #e8e4dc;
  border-radius: 10px;
  padding: 24px;
  background-color: #fdfcfa;
  margin-bottom: 20px;
}

.enquete-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 2px solid #DEC067;
}

.enquete-card-title {
  font-size: 20px;
  font-weight: 500;
  color: #424E58;
  padding: 0;
  margin: 0;
}

.enquete-vraag {
  padding: 12px 0;
  border-bottom: 1px solid #f0ede6;
}

.enquete-vraag:last-child {
  border-bottom: none;
}

.enquete-vraag-tekst {
  font-size: 15px;
  font-weight: 500;
  color: #424E58;
  padding: 0 0 4px 0;
}

/* Success dialog */
.enquete-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px;
  text-align: center;
}

.enquete-dialog-icon {
  margin-bottom: 12px;
}

.enquete-dialog-title {
  font-size: 20px;
  font-weight: 500;
  color: #424E58;
  padding: 0;
  margin: 0;
}
</style>
